import React from 'react';

const NotFound = () => {
  return <div className='not-found-root'>Page Not Found</div>;
};

export default NotFound;
